import { faMoneyBill } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ConsumerUserAccount } from "@interfaces/consumer/users";
import { KeyValueSet } from "@interfaces/helpers";
import {FC, useState} from "react";
import ChargeGameAccountModal from "./chargeGameAccountModal";
import {useGameServers, useLoginServer} from "@hooks/selectors/consumer/project.selectors";
import {Dropdown} from "react-bootstrap";

interface ChargeGameAccountIconProps {
    account: ConsumerUserAccount;
}

const ChargeGameAccountIcon: FC<ChargeGameAccountIconProps> = ({ account }) => {

    const login = useLoginServer(account.loginId);
    const games = useGameServers(account.loginId);

    const id = `login-${login?.id}-account-${account.id}`;

    const gameModalsInit: KeyValueSet<boolean> = {};
    games.forEach(game => gameModalsInit[game.id] = false);

    const [loginModal, setLoginModal] = useState(false);
    const [gameModals, setGameModals] = useState(gameModalsInit);

    const toggleGameModal = (gameId: string) => {
        setGameModals(prevState => ({
            ...prevState,
            [gameId]: !prevState[gameId]
        }));
    }

    if (!login) {
        return null;
    }

    const loginCharge = login.canCharge && login.isActive;
    const gamesToCharge = games.filter(game => game.canCharge && game.isActive);

    if(!loginCharge && gamesToCharge.length === 0) {
        return null;
    }

    return (
        <Dropdown className="font-sans-serif btn-reveal-trigger"
                  align="end"
        >
            <Dropdown.Toggle
                variant="reveal"
                size="sm"
                data-boundary="viewport"
                className="text-600 btn-reveal"
            >
                <FontAwesomeIcon
                    id={id}
                    icon={faMoneyBill}
                    className="fs-11"/>
            </Dropdown.Toggle>
            <Dropdown.Menu className="border py-0">
                <div className="py-2">
                    {
                        loginCharge && (
                            <Dropdown.Item onClick={() => setLoginModal(true)}>
                                На логинсервер
                            </Dropdown.Item>
                        )
                    }
                    {
                        gamesToCharge.map(game => (
                            <Dropdown.Item key={game.id} onClick={() => toggleGameModal(game.id)}>
                                На геймсервер {game.name}
                            </Dropdown.Item>
                        ))
                    }
                </div>
            </Dropdown.Menu>
            {
                loginCharge && (
                    <ChargeGameAccountModal
                        id={`${login.id}-${account.id}`}
                        account={account}
                        login={login}
                        isOpened={loginModal}
                        toggle={() => setLoginModal(false)}/>
                )
            }
            {
                gamesToCharge.map(game => (
                    <ChargeGameAccountModal
                        id={`${login.id}-${game.id}-${account.id}`}
                        account={account}
                        login={login}
                        game={game}
                        isOpened={gameModals[game.id]}
                        toggle={() => toggleGameModal(game.id)}/>
                ))
            }
        </Dropdown>
    )
}

export default ChargeGameAccountIcon;